export default __webpack_public_path__ + "static/media/search.57fea021.svg";